import { createMuiTheme, makeStyles} from '@material-ui/core/styles';
import { estilosTextosPrincipales, colores, tipografia } from '../../../AppStyle';

export const customStyle = makeStyles ({
 
    alertClass:{
        textDecorationLine: 'underline',
        cursor: 'pointer',
        marginBottom: '3px',
        paddingTop: "0.2%",
        paddingLeft: "0.5%",
    },

    alertGrid:{
        display: "inline-flex",
        marginLeft: "1%",
        flexWrap: "nowrap",
    },

    iconClass:{
        color: "#B00020",
    }

});

const theme = createMuiTheme({
    overrides: {
        //Nombre de la clase CSS
        MuiAlert: {
            // Nombre de la regla hija sobre la que se aplica            
            outlinedError: {
                // Some CSS
                boxSizing: 'border-box',
                height: 'fit-content',
                width: '90%',
                margin: 'auto',
                border: '1px ',
                borderColor: '#EA4648',
                borderStyle: 'solid ',
                background: '#FFF5F7',
                boxShadow: '0 0 6px 0 rgba(188,197,201,0.5), 0 0 30px 0 rgba(188,197,201,0.28)',
            },
            message: {
                ...estilosTextosPrincipales.body2,
                color: '#B00020',
                letterSpacing: '0.24px',
                width: "100%",
            }
        },
        MuiTypography: {
            body1: {
                color: colores.escalaGrises.cien,
                fontFamily: tipografia.regular,
                fontSize: '19.46px',
                fontWeight: '500',
                letterSpacing: '0',
                lineHeight: '29px',
                textDecoration: 'none',
                paddingLeft: "1%",
            },
        }
    },
});

export default theme;